export const NEW_USER_REGISTRATION_TAG_NAME = 'tm-bo-new-user-registration';
